import React from "react";
import { Col } from "react-bootstrap";

import {
  IControlStyles,
  PageContent,
  useControlStyles,
} from "../../../assets/layouts";
import { VfxLib } from "../../../assets/vfx";
import Control from "../../../assets/vfx/controls/control";
import { SearchDto, SearchOperator } from "../../../assets/utils/lib/searchDto";

import {
  defaultSearchQuery,
  GRID_ACTION_TYPES,
} from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import Form from "../../../assets/vfx/form/form";
import { SearchContainer } from "../../../assets/vfx/search/searchContainer";
import { AnswerTypeService } from "./answerTypeService";

interface AnswerTypePageProps {
  controlStyles?: IControlStyles | undefined;
  onCustomEvent?: (actionType: string, dataId: string) => void;
}

interface AnswerTypeSearch {
  name: string;
}

const searchInitialValues: AnswerTypeSearch = {
  name: Constants.emptyString,
};

export const AnswerTypePage = (props: AnswerTypePageProps) => {
  const [searchQuery, setSearchQuery] =
    React.useState<SearchDto>(defaultSearchQuery);
  const answertypeGridQuery = AnswerTypeService.gridQuery(searchQuery);
  const isGridLoading =
    answertypeGridQuery.isLoading || answertypeGridQuery.isFetching;
  const styles: IControlStyles = props.controlStyles ?? useControlStyles();
  const handleSearch = (values: AnswerTypeSearch): void => {
    const filters = [];
    if (values.name.trim() !== Constants.emptyString) {
      filters.push({
        field: "name",
        operator: SearchOperator.Contains,
        value: values.name,
      });
    }

    if (filters.length > 0 && Array.isArray(defaultSearchQuery.filters)) {
      filters.push(...defaultSearchQuery.filters);
    }

    if (filters.length > 0) {
      setSearchQuery({
        ...defaultSearchQuery,
        filters,
      });
    }
  };

  function handleNew() {
    props.onCustomEvent?.(GRID_ACTION_TYPES.NEW, Constants.emptyGuid);
  }

  const handleClear = (): void => {
    setSearchQuery((prev) => ({
      ...defaultSearchQuery,
      sorts: prev.sorts,
      pageSize: prev.pageSize ?? 10,
    }));
  };
  return (
    <PageContent title="Answer Types">
      <SearchContainer
        initialValues={searchInitialValues}
        onSearch={handleSearch}
        onNew={handleNew}
        onClear={handleClear}
        enableReinitialize
      >
        <Col lg={4}>
          <Form.Text name={"name"} label={"Name"} />
        </Col>
      </SearchContainer>
      <Control.DataGrid
        dataId="id"
        height="55vh"
        cols={[
          {
            data: "id",
            title: "ID",
            visible: false,
            columnType: "number",
            alignment: "right",
            sortable: false
          },
          {
            data: "name",
            title: "Name",
            visible: true,
            columnType: "text",
            alignment: "left",
            sortable: false,
            width: "18%",
          },
          {
            data: "description",
            title: "Description",
            visible: true,
            columnType: "text",
            alignment: "left",
            width: "24%",
          },
        ]}
        actionCol={{
          data: "id",
          title: "Action",
          visible: true,
          columnType: "action",
          alignment: "right",
          width: "100px",
          controlStyles: styles,
          actionButtons: [
            VfxLib.datagridActionButtons({ datagridStyles: styles }).edit,
            VfxLib.datagridActionButtons({ datagridStyles: styles }).view,
          ],
        }}
        onCustomEvent={props.onCustomEvent}
        data={answertypeGridQuery?.data?.result ?? []}
        isActionButtonClick={true}
        totalRecords={
          answertypeGridQuery.data?.totalSize ??
          answertypeGridQuery?.data?.result?.length ??
          0
        }
        query={searchQuery}
        loading={isGridLoading}
        onQueryChange={(patch) => {
          setSearchQuery((query) => ({
            ...query,
            ...patch,
            sorts: patch.sortBy ? [patch.sortBy] : query.sorts,
          }));
        }}
      />
    </PageContent>
  );
};
